import React from "react";

export default function EditBillModal({
  show,
  editBill,
  setEditBill,
  saving,
  onClose,
  onSave,
  toDateInput,
  parseDateInput,
}) {
  if (!show || !editBill) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 text-xs">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-slate-800">Edit Payable / Purchase</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">✕</button>
        </div>

        <div className="grid md:grid-cols-3 gap-3">
          <div className="md:col-span-1">
            <label className="block text-slate-600 mb-1">Vendor / OEM</label>
            <input
              className="border border-slate-200 rounded px-2 py-1 w-full"
              value={editBill.vendor}
              onChange={(e) => setEditBill((p) => ({ ...p, vendor: e.target.value }))}
            />
          </div>

          <div>
            <label className="block text-slate-600 mb-1">Type</label>
            <select
              className="border border-slate-200 rounded px-2 py-1 w-full"
              value={editBill.billType}
              onChange={(e) => setEditBill((p) => ({ ...p, billType: e.target.value }))}
            >
              <option value="Proforma">Proforma</option>
              <option value="Invoice">Invoice</option>
            </select>
          </div>

          <div>
            <label className="block text-slate-600 mb-1">Invoice / Proforma No</label>
            <input
              className="border border-slate-200 rounded px-2 py-1 w-full"
              value={editBill.billNo}
              onChange={(e) => setEditBill((p) => ({ ...p, billNo: e.target.value }))}
            />
          </div>

          <div>
            <label className="block text-slate-600 mb-1">Bill Date</label>
            <input
              type="date"
              className="border border-slate-200 rounded px-2 py-1 w-full"
              value={toDateInput(editBill.billDate)}
              onChange={(e) => setEditBill((p) => ({ ...p, billDate: parseDateInput(e.target.value) }))}
            />
          </div>

          <div>
            <label className="block text-slate-600 mb-1">Due Date (optional)</label>
            <input
              type="date"
              className="border border-slate-200 rounded px-2 py-1 w-full"
              value={toDateInput(editBill.dueDate)}
              onChange={(e) => setEditBill((p) => ({ ...p, dueDate: parseDateInput(e.target.value) }))}
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-slate-600 mb-1">Currency</label>
              <select
                className="border border-slate-200 rounded px-2 py-1 w-full"
                value={editBill.currency}
                onChange={(e) =>
                  setEditBill((p) => ({
                    ...p,
                    currency: e.target.value,
                    fxRateToAED: e.target.value === "AED" ? "1" : p.fxRateToAED,
                  }))
                }
              >
                <option value="AED">AED</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="GBP">GBP</option>
                <option value="SAR">SAR</option>
                <option value="OMR">OMR</option>
                <option value="INR">INR</option>
                <option value="CNY">CNY</option>
              </select>
            </div>

            <div>
              <label className="block text-slate-600 mb-1">FX rate → AED</label>
              <input
                type="number"
                step="0.0001"
                className="border border-slate-200 rounded px-2 py-1 w-full"
                value={editBill.fxRateToAED}
                onChange={(e) => setEditBill((p) => ({ ...p, fxRateToAED: e.target.value }))}
                disabled={editBill.currency === "AED"}
              />
            </div>
          </div>
        </div>

                {/* Items table */}
<div className="border rounded-xl overflow-hidden mt-3">
  <div className="bg-slate-100 px-3 py-2 text-[11px] font-semibold text-slate-700">
    Item Table (enter Value in selected currency)
  </div>

  <div className="p-3 space-y-2">
    {(editBill.items || [{ item: "", qty: "", value: "" }]).map((r, idx) => (
      <div key={idx} className="grid md:grid-cols-12 gap-2 items-center">
        <input
          className="border border-slate-200 rounded px-2 py-1 md:col-span-6"
          placeholder="Item name / details"
          value={r.item || ""}
          onChange={(e) =>
            setEditBill((p) => {
              const items = [...(p.items || [])];
              items[idx] = { ...items[idx], item: e.target.value };
              return { ...p, items };
            })
          }
        />

        <input
          type="number"
          className="border border-slate-200 rounded px-2 py-1 md:col-span-2"
          placeholder="Qty"
          value={r.qty ?? ""}
          onChange={(e) =>
            setEditBill((p) => {
              const items = [...(p.items || [])];
              items[idx] = { ...items[idx], qty: e.target.value };
              return { ...p, items };
            })
          }
        />

        <div className="md:col-span-3">
          <input
            type="number"
            className="border border-slate-200 rounded px-2 py-1 w-full"
            placeholder={`Value (${editBill.currency || "AED"})`}
            value={r.value ?? ""}
            onChange={(e) =>
              setEditBill((p) => {
                const items = [...(p.items || [])];
                items[idx] = { ...items[idx], value: e.target.value };
                return { ...p, items };
              })
            }
          />
          <div className="mt-1 text-[10px] text-slate-500">
            AED:{" "}
            <b>
              {(
                (Number(r.qty || 0) || 0) *
                (Number(r.value || 0) || 0) *
                (Number(editBill.fxRateToAED || 1) || 1)
              ).toFixed(2)}
            </b>
          </div>
        </div>

        <button
          className="md:col-span-1 text-red-600 hover:text-red-700"
          title="Remove row"
          onClick={() =>
            setEditBill((p) => {
              const items = (p.items || []).filter((_, i) => i !== idx);
              return { ...p, items: items.length ? items : [{ item: "", qty: "", value: "" }] };
            })
          }
        >
          ×
        </button>
      </div>
    ))}

    <button
      className="px-3 py-1.5 rounded bg-slate-800 text-white text-xs"
      onClick={() =>
        setEditBill((p) => ({ ...p, items: [...(p.items || []), { item: "", qty: "", value: "" }] }))
      }
    >
      + Add New Row
    </button>

    {/* Note + Paid */}
    <div className="grid md:grid-cols-3 gap-3 pt-2">
      <div className="md:col-span-2">
        <label className="block text-slate-600 mb-1">Note</label>
        <input
          className="border border-slate-200 rounded px-2 py-1 w-full"
          value={editBill.note || ""}
          onChange={(e) => setEditBill((p) => ({ ...p, note: e.target.value }))}
          placeholder="Optional notes"
        />
      </div>

      <div>
        <label className="block text-slate-600 mb-1">Paid (AED)</label>
        <input
          type="number"
          className="border border-slate-200 rounded px-2 py-1 w-full"
          value={editBill.paidAED ?? ""}
          onChange={(e) => setEditBill((p) => ({ ...p, paidAED: e.target.value }))}
          placeholder="0"
        />
      </div>
    </div>

    {/* Subtotals */}
    {(() => {
      const fx = Number(editBill.currency) === "AED" ? 1 : (Number(editBill.fxRateToAED || 1) || 1);
      const subOriginal = (editBill.items || []).reduce(
        (s, r) => s + (Number(r.qty || 0) || 0) * (Number(r.value || 0) || 0),
        0
      );
      const subAED = subOriginal * fx;

      return (
        <div className="mt-2 grid md:grid-cols-2 gap-2 text-[11px]">
          <div className="rounded-lg bg-slate-50 border border-slate-200 p-2">
            <div className="text-slate-500">Subtotal ({editBill.currency || "AED"})</div>
            <div className="font-semibold">{subOriginal.toFixed(2)}</div>
          </div>

          <div className="rounded-lg bg-slate-50 border border-slate-200 p-2">
            <div className="text-slate-500">Subtotal (AED)</div>
            <div className="font-semibold">{subAED.toFixed(2)}</div>
          </div>
        </div>
      );
    })()}
  </div>
</div>

        <div className="flex justify-end gap-2 mt-4">
          <button className="px-3 py-1.5 rounded border border-slate-200 text-slate-600" onClick={onClose}>
            Cancel
          </button>
          <button
            className="px-3 py-1.5 rounded bg-slate-800 text-white disabled:opacity-60"
            disabled={saving}
            onClick={onSave}
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}
